import { Box } from '@mui/material';

import privacyContactEmail from './privacyContactEmail.png';
import {
  bodyParagraphs,
  closingParagraphs,
  contactBoxParagraphs,
  PolicyParagraph,
} from './privacyPolicyAppContent';

// 原本（Word）の書式に合わせた寸法。1px = 15twip = 9525EMU（96dpi換算）
const fontFamily =
  '"游明朝", "Yu Mincho", YuMincho, "Hiragino Mincho ProN", "Noto Serif JP", serif';
const contentWidth = '650px'; // A4幅 - 左右余白 0.75in
const lineHeight = '18pt'; // 行送り（グリッド線 18pt）
const numberIndent = '24px'; // 段落番号のぶら下げ 360twip
const contactBoxWidth = '563px';
const contactBoxMinHeight = '122px';
const contactEmailWidth = '191px';

const Paragraph = ({ paragraph }: { paragraph: PolicyParagraph }) => {
  const runs =
    typeof paragraph.runs === 'string'
      ? paragraph.runs
      : paragraph.runs.map((run, i) => (
          <Box
            key={i}
            component="span"
            sx={{
              fontWeight: run.bold ? 'bold' : undefined,
              textDecoration: run.underline ? 'underline' : undefined,
              fontSize: run.size ? `${run.size}pt` : undefined,
            }}
          >
            {run.text}
          </Box>
        ));

  return (
    <Box
      component="p"
      sx={{
        m: 0,
        minHeight: lineHeight,
        textAlign: paragraph.align ?? 'justify',
        display: paragraph.number ? 'flex' : undefined,
      }}
    >
      {paragraph.number ? (
        <>
          <Box component="span" sx={{ width: numberIndent, flexShrink: 0 }}>
            {paragraph.number}
          </Box>
          <span>{runs}</span>
        </>
      ) : (
        runs
      )}
    </Box>
  );
};

const PrivacyPolicyApp = () => {
  return (
    <Box sx={{ minHeight: '100%', bgcolor: '#fff', color: '#000' }}>
      <Box
        sx={{
          maxWidth: contentWidth,
          boxSizing: 'content-box',
          mx: 'auto',
          px: { xs: '16px', sm: '72px' },
          py: { xs: '24px', sm: '96px' },
          fontFamily,
          fontSize: '10.5pt',
          lineHeight,
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
        }}
      >
        {bodyParagraphs.map((paragraph, i) => (
          <Paragraph key={i} paragraph={paragraph} />
        ))}
        <Box
          sx={{
            width: 1,
            maxWidth: contactBoxWidth,
            minHeight: contactBoxMinHeight,
            px: '9.6px',
            py: '4.8px',
            border: '1pt solid #7f7f7f',
            color: '#0d0d0d',
          }}
        >
          {contactBoxParagraphs.map((paragraph, i) => (
            <Paragraph key={i} paragraph={paragraph} />
          ))}
          <Box component="p" sx={{ m: 0 }}>
            <Box
              component="img"
              src={privacyContactEmail}
              alt="tpjkm_privacy@toppan.co.jp"
              sx={{
                width: contactEmailWidth,
                maxWidth: 1,
                verticalAlign: 'bottom',
              }}
            />
          </Box>
        </Box>
        {closingParagraphs.map((paragraph, i) => (
          <Paragraph key={i} paragraph={paragraph} />
        ))}
      </Box>
    </Box>
  );
};

export default PrivacyPolicyApp;
